export default __webpack_public_path__ + "static/radicalizing-news-1ab76d6f4aab48ac33acdce5d9bfd91f.jpeg";